// TM-1000001816: Entity-Provider fuer das HE-Modul (Integration Connection
// Registry). Registriert beide Aliase mit route + objectRoute + objectComponent.
// objectRoute MUSS mit den Pfaden in he.route.ts uebereinstimmen, damit die
// Navigation per Row-Click aufloest. Struktur gespiegelt vom IN-Modul.
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from '../../core/shared/dto/dto-service/entity-service-registry';
import {MvsCrudModeEnum} from '../../core/shared/service/crud/mvs-crud-mode.enum';
import {
    HeSftpConnectionObjectComponent
} from './component/object-components/he-sftp-connection-object-component/he-sftp-connection-object.component';
import {
    HeFtpConnectionObjectComponent
} from './component/object-components/he-ftp-connection-object-component/he-ftp-connection-object.component';

export const HE_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            // TM-1000001816: objectRoute + Object-Components fuer Detail-Pages.
            ['he.IntegrationSftpConnection', {
                route: '/he/integrationSftpConnections',
                objectRoute: '/he/sftpConnection/:id',
                objectComponent: [{mode: MvsCrudModeEnum.update, component: HeSftpConnectionObjectComponent}]
            }],
            ['he.IntegrationFtpConnection', {
                route: '/he/integrationFtpConnections',
                objectRoute: '/he/ftpConnection/:id',
                objectComponent: [{mode: MvsCrudModeEnum.update, component: HeFtpConnectionObjectComponent}]
            }],
        ] as EntityServiceEntry[],
        multi: true
    }
];
